/**
 * ConfirmDialog — Modal de confirmação com variante danger
 */
import { T } from '../../styles/tokens';
import { Modal } from './Modal';

interface ConfirmDialogProps {
  /** Se o modal está aberto */
  open: boolean;
  /** Callback ao fechar/cancelar */
  onClose: () => void;
  /** Callback ao confirmar */
  onConfirm: () => void;
  /** Título do diálogo */
  title?: string;
  /** Mensagem de confirmação */
  message: string;
  /** Texto do botão confirmar */
  confirmText?: string;
  /** Texto do botão cancelar */
  cancelText?: string;
  /** Variante danger (botão vermelho) */
  danger?: boolean;
  /** Desabilitar botão confirmar (ex: durante loading) */
  loading?: boolean;
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = 'Confirmar',
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  danger = false,
  loading = false,
}: ConfirmDialogProps) {
  const confirmBg = danger ? T.danger : T.primary;
  const confirmHoverBg = danger ? T.dangerHover : T.primaryHover;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      width={380}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: T.space3 }}>
          <button
            onClick={onClose}
            style={{
              padding: `${T.space2}px ${T.space4}px`,
              borderRadius: T.radiusMd,
              border: `1px solid ${T.border}`,
              background: 'transparent',
              color: T.textSecondary,
              fontSize: T.textMd,
              cursor: 'pointer',
              transition: `background ${T.transitionFast}`,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = T.bgCardHover)}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            {cancelText}
          </button>
          <button
            onClick={() => { if (!loading) onConfirm(); }}
            disabled={loading}
            style={{
              padding: `${T.space2}px ${T.space4}px`,
              borderRadius: T.radiusMd,
              border: 'none',
              background: confirmBg,
              color: T.text,
              fontSize: T.textMd,
              fontWeight: T.weightSemibold,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: `background ${T.transitionFast}`,
            }}
            onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = confirmHoverBg; }}
            onMouseLeave={(e) => { if (!loading) e.currentTarget.style.background = confirmBg; }}
          >
            {loading ? '...' : confirmText}
          </button>
        </div>
      }
    >
      <p style={{ color: T.textSecondary, fontSize: T.textMd, margin: 0, lineHeight: 1.5 }}>
        {message}
      </p>
    </Modal>
  );
}
